import cookies from 'js-cookie';

import { RequestService } from '@/api/services/request.service';
import { unsubscribeWebPush } from '@/api/web-push/unsubscribe-web-push';
import { REFRESH_TOKEN_NAME, TOKEN_COOKIE_NAME, USER_LOGGED_KEY_NAME } from '@/auth/constants';
import { LocalStorage } from '@/utils';

export const logout = async () => {
	const request = RequestService.getInstance();

	if ('serviceWorker' in navigator) {
		const registration = await navigator.serviceWorker.getRegistration('/');
		const subscription = await registration?.pushManager.getSubscription();

		if (subscription) {
			await unsubscribeWebPush(subscription.endpoint);
		}
	}

	await request.delete('accounts/logout');
	cookies.remove(TOKEN_COOKIE_NAME);
	cookies.remove(REFRESH_TOKEN_NAME);
	LocalStorage.removeItem(USER_LOGGED_KEY_NAME);
	RequestService.clearAuthHeader();
};
